import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import * as global from '../../global';
import {Location} from '@angular/common';
import { lastValueFrom, of } from 'rxjs';
import { FaceSheetService } from './face-sheet.service';

@Component({
  selector: 'app-facesheet',
  templateUrl: './facesheet.component.html',
  styleUrls: ['./facesheet.component.css']
})
export class FacesheetComponent implements OnInit {
  @Input() patient_id: any;
  @Output() onCloseFacesheet = new EventEmitter<any>();
  patient;

  patientCoverages;

  currentUser:any;
  matrixCareCoverages;
  loaderId = 'facesheet-loader';
  inprogress = false;
  secondaryIns = ''
  primaryArray = [];
  secondaryArray = [];
  primaryObj = {};
  secondaryObj = {};
  coverages  = [] 
  constructor(
    private route:ActivatedRoute,
    private authService:AuthService,
    private loader: NgxUiLoaderService,
    private toastr:ToastrService,
    private _location: Location,
    private faceSheetService:FaceSheetService
  ) { 
    this.currentUser = this.authService.currentUser;
    
    
  }
  goBack() {
    if(this.currentUser.user_type == '6') {
      this.onCloseFacesheet.emit(false);
    }
    else {
      this._location.back();

    }
}

  async ngOnInit() {
    const patient_id = this.route.snapshot.params.id || this.patient_id;
    await this.syncCoveragesData(patient_id);
    // debugger
    // await this.initPatient(patient_id);
  }
  
  generateFacesheetAndDownload(patientId) {
    // this.toastr.info('Generating PDF', 'Please wait...');
    this.inprogress = true;
    const coverageData = { 
      patient: this.patient,
      coverages : this.coverages
    }
    this.faceSheetService.generateFacesheetAndDownloadAsPDF(coverageData); 
  }

  getLevelName(number: number ) {
    switch (number) {
        case 1:
            return "Primary";
        case 2:
            return "Secondary";
        case 3:
            return "Tertiary";
        default:
            return "Other";
    }
  }

  async syncCoveragesData(patientId) {
    this.loader.startLoader(this.loaderId);
    const details = {
      ...this.authService.authObject,
      patientId,
    }
      const {status, data} =  await lastValueFrom(this.faceSheetService.getCoveragesData({details})) as any;
      if(status === 200) {
        this.patient = data.patient_data;
        this.coverages = data.coverage_data;
        this.loader.stopLoader(this.loaderId);
      }
      else{
        this.patient = {};
        this.coverages = [];
        this.loader.stopLoader(this.loaderId);
      }
  }
  
}
